/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import { useTheme } from 'react-jss';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Tooltip.style';
import { isSsr } from 'src/shared/core/util/ssrUtil';

const useStyles = createUseThemeStyles(styles);

const Tooltip = (): React.Node => {
  const classes = useStyles();
  const { accentColor, colorPrimary, textColor } = useTheme();
  if (isSsr) return false;
  return (
    <ReactTooltip
      effect="solid"
      className={classes.rootTooltip}
      border
      textColor={textColor}
      backgroundColor={colorPrimary}
      borderColor={accentColor}
      arrowColor={colorPrimary}
    />
  );
};

export default Tooltip;
